var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression, alias2=container.lambda;

  return "<div class=\"webTableNotification\">\n    <span>"
    + alias1(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"pos.weborder.link",{"name":"i18n","hash":{},"data":data}))
    + "</span><a href=\""
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.restaurant : depth0)) != null ? stack1.webURL : stack1), depth0))
    + "/"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.table : depth0)) != null ? stack1.name : stack1), depth0))
    + "\" target=\"_blank\">"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.restaurant : depth0)) != null ? stack1.webURL : stack1), depth0))
    + "/"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.table : depth0)) != null ? stack1.name : stack1), depth0))
    + "</a>\n</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;

  return "    <thead>\n        <th class=\"bSpace\">"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.time",{"name":"i18n","hash":{},"data":data}))
    + "</th>\n        <th class=\"bSpace\">"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.amount",{"name":"i18n","hash":{},"data":data}))
    + "</th>\n        <th class=\"bSpace\">"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.name",{"name":"i18n","hash":{},"data":data}))
    + "</th>\n        <th class=\"dSpace\">"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.phone",{"name":"i18n","hash":{},"data":data}))
    + "</th>\n        <th class=\"bSpace\">"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,"pos.status",{"name":"i18n","hash":{},"data":data}))
    + "</th>\n    </thead>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "        <tr class=\"webbill\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">\n            <td class=\"time bSpace\">"
    + alias2(alias1((depth0 != null ? depth0.time : depth0), depth0))
    + "</td>\n            <td class=\"name bSpace\">"
    + alias2(alias1((depth0 != null ? depth0.currency : depth0), depth0))
    + alias2(alias1((depth0 != null ? depth0.amount : depth0), depth0))
    + "</td>\n            <td class=\"name bSpace\">"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</td>\n            <td class=\"phone dSpace\">"
    + alias2(alias1((depth0 != null ? depth0.phone : depth0), depth0))
    + "</td>\n            <td class=\"status bSpace\">"
    + alias2(alias1((depth0 != null ? depth0.status : depth0), depth0))
    + "</td>\n        </tr>\n";
},"7":function(container,depth0,helpers,partials,data) {
    return "        <tr class=\"bill shallow pitem\">\n            <td class=\"tableName\" colspan=\"5\" style=\"text-align: center;font-size: 15px;background-color: transparent;margin-left: 10px\">\n                "
    + container.escapeExpression(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"pos.today.emptyWebBills",{"name":"i18n","hash":{},"data":data}))
    + "\n            </td>\n        </tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.webTable : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"tablecontainer\">\n<table class=\"table\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.bills : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <tbody>\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.bills : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.bills : depth0),{"name":"unless","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </tbody>\n</table>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/table/WebBillList.handlebars
// module id = 563
// module chunks = 0